import { render, staticRenderFns } from "./EditorTransfers.vue?vue&type=template&id=bcaceae4"
import script from "./EditorTransfers.vue?vue&type=script&lang=js"
export * from "./EditorTransfers.vue?vue&type=script&lang=js"
import style0 from "./EditorTransfers.vue?vue&type=style&index=0&id=bcaceae4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports